import {
    AlertDialog,
    AlertDialogOverlay,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogCloseButton,
    AlertDialogBody,
    AlertDialogFooter,
    Button,
    Icon,
    useColorModeValue,
    Text,
    Flex,
    Link,
    Box,
    Image
} from '@chakra-ui/react';
import { useRef } from 'react';
import { RefreshIcon } from './UiElements';
import { reloadApp } from '../../platformFiles/platformMessages';
import { PLATFORM } from '../../platformFiles/utils/platformConstants';

export const BootFailModal = ({ error }) => {
    const color = useColorModeValue('gray.100', '#1c1e20');
    const text = useColorModeValue('#1A202C', '#FFF');
    const iconSmall = useColorModeValue('gray.600', '#FFF');
    const bgFade = useColorModeValue('#dbdde2', '#20252a');
    const btnRef = useRef();
    const reloadRef = useRef();

    const reloadExtension = () => {
        reloadApp();
    };

    const hideBootFailModal = () => {};

    console.log('tabExtend error:', error);

    return (
        <>
            <AlertDialog
                leastDestructiveRef={reloadRef}
                finalFocusRef={btnRef}
                onClose={hideBootFailModal}
                isOpen={true}
            >
                <AlertDialogOverlay bg={bgFade} />
                <AlertDialogContent rounded="12px" bg="modalBg">
                    <AlertDialogHeader mt="24px" pb="8px" color={text}>
                        Oh no 🚧 - Something went wrong
                    </AlertDialogHeader>
                    {/* <AlertDialogCloseButton
                        size="sm"
                        mt="4px"
                        color={iconSmall}
                        transition="0s"
                        rounded="6px"
                    /> */}
                    <AlertDialogBody
                        color={text}
                        bg={color}
                        py="16px"
                        fontSize="14px"
                        mb="16px"
                    >
                        <Text>
                            tabExtend encountered an unexpected error. Please
                            try reloading the app.
                        </Text>

                        <Text mt="8px">
                            If the issue persists, reach out to
                            <Link
                                href="mailto:support@tabextend.com"
                                color="blue.400"
                                mx="4px"
                            >
                                support@tabextend.com
                            </Link>
                            for assistance.
                        </Text>
                    </AlertDialogBody>
                    <AlertDialogFooter px="16px">
                        <Button
                            onClick={() => reloadExtension()}
                            ml="auto"
                            ref={reloadRef}
                            color="#FFF"
                            backgroundImage="linear-gradient(145deg, #5DABFE 0%, #3391FF 100%)"
                            _hover={{
                                backgroundImage:
                                    'linear-gradient(145deg, #3592FE 0%, #2E7EDB 100%)'
                                /* boxShadow:
                                    '0 10px 16px -8px rgba(49, 144, 255,0.5)' */
                            }}
                            boxShadow="0 12px 18px -10px rgba(49, 144, 255,0.35)"
                            rounded="8px"
                            transition="0s"
                            fontSize="15px"
                            pl="24px"
                            pr="32px"
                            leftIcon={<Icon as={RefreshIcon} p="2px" />}
                        >
                            {PLATFORM === 'web'
                                ? 'Reload app'
                                : 'Reload  extension'}
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialog>
        </>
    );
};

export const GroupErrorFallback = ({ error }) => {
    const imageSrc = useColorModeValue(
        '../../assets/images/GroupError_Image.png',
        '../../assets/images/GroupError_ImageDark.png'
    );
    const bg = useColorModeValue('#8c9eb036', '#4f525536');

    return (
        <Flex
            position="absolute"
            top="0"
            left="0"
            right="0"
            bottom="0"
            bg={bg}
            zIndex="999"
            justifyContent="center"
            alignItems="center"
            height="100%"
            width="100%"
            rounded="18px"
        >
            <Box alignItems={'center'} textAlign={'center'}>
                <Image
                    src={imageSrc}
                    boxSize="124px"
                    minW="124px"
                    mb="16px"
                    borderStyle="none"
                    border="0px"
                    borderColor="transparent"
                    pointerEvents="none"
                    userSelect="none"
                    mx="auto"
                />
                <Text mx="auto" fontSize="12px" fontWeight="600">
                    Error loading this group
                </Text>
                <Text mt="8px" fontSize="11px" mx="auto">
                    If issue persists, contact support at <br />
                    <Link href="mailto:support@tabextend.com" color="blue.400">
                        support@tabextend.com
                    </Link>
                </Text>
            </Box>
        </Flex>
    );
};
